import React from 'react';
import Carousel from 'react-material-ui-carousel';

/**
 * Images qui s'afficheront en carrousel
 * @param props props
 * @constructor
 */
export function CarrouselCustom(props: { images: string[] }) {
    //Permet de gérer le cas ou les images sont mal formatées
    //Si l'image n'est pas interprétée correctement alors on affiche un logo par défaut
    return (
        <Carousel
            className={'carrousel'}
            navButtonsAlwaysVisible={true}
            changeOnFirstRender={true}
            navButtonsProps={{
                style: { backgroundColor: '#3e5ca7' },
            }}
            indicators={false}
        >
            {props.images.map(image => (
                <img key={image} className={'imageCarrousel'} src={image} width={'100%'} alt={'carrousel-img'} />
            ))}
        </Carousel>
    );
}
